import React from 'react';
import styled from 'styled-components';
import PrimaryButton from '../forms/Button/PrimaryButton';

interface DuplicateCheckModalProps {
  isOpen: boolean;
  message: string;
  onClose: () => void;
}

const DuplicateCheckModal: React.FC<DuplicateCheckModalProps> = ({ isOpen, message, onClose }) => {
  if (!isOpen) return null;

  return (
    <ModalOverlay>
      <ModalContent>
        <ModalHeader>
          <h2>Duplicate Check</h2>
        </ModalHeader>
        <ModalBody>
          <p>{message}</p>
        </ModalBody>
        <ModalFooter>
          <PrimaryButton type="button" title="Close" onClick={onClose} />
        </ModalFooter>
      </ModalContent>
    </ModalOverlay>
  );
};

export default DuplicateCheckModal;

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

const ModalContent = styled.div`
  background: white;
  padding: 20px;
  border-radius: 8px;
  width: 400px;
  max-width: 90%;
`;

const ModalHeader = styled.div`
  margin-bottom: 10px;
`;

const ModalBody = styled.div`
  margin-bottom: 20px;
`;

const ModalFooter = styled.div`
  display: flex;
  justify-content: flex-end;
`;